module.exports = __webpack_public_path__ + "static/media/globos.53af6b07.png";